<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('anniversaries')">Anniversary Message</inertia-link>
      <span class="text-indigo-400 font-medium">/</span> Create
    </h1>
    <badge-preview :preview_anniversary=form.anniversary :preview_message=form.message />
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.anniversary" class="pr-6 pb-8 w-full" label="Twitch Anniversary" :error="this.$page.props.errors.anniversary"/>
          <textarea-input v-model="form.message" class="pr-6 pb-8 w-full" label="Anniversary Message" rows="4" max-rows="6" :error="this.$page.props.errors.message"/>
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Create </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TextareaInput from '../../Shared/TextareaInput.vue'
import BadgePreview from '@/Shared/BadgePreview.vue'

export default {
  metaInfo: { title: 'Create Twitch Sub Anniversary Message' },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
    TextareaInput,
    BadgePreview,
  },
  layout: Layout,
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        anniversary: null,
        message: null,
      }),
    }
  },
  methods: {
    store() {
      this.form.post(this.route('anniversaries.store'))
    },
    update() {
      this.form.put(this.route('anniversaries.update', this.anniversary.id))
    },
  },
}
</script>
